import { Component, ElementRef, EventEmitter, Input, OnChanges, Output, SimpleChanges, ViewChild, ViewEncapsulation } from '@angular/core';
import { maxFileSize } from '../../constants/constants';
import { LocalStorageService } from '../../services/local-storage.service';
import { showAlert, showConfirmAlert } from '../../utils/alert';
import { environment } from './../../../environments/environment';

@Component({
	selector: 'app-file-input',
	templateUrl: './file-input.component.html',
	styleUrls: ['./file-input.component.scss'],
	encapsulation: ViewEncapsulation.None
})
export class FileInputComponent implements OnChanges {
	@Input() label: string = '';
	@Input() fileUrl?: string | null = '';
	@Input() defaultFilename?: string | null = '';
	@Input() preview?: boolean = false;
	@Input() disabled: boolean = false;

	@Output() uploadedFile: EventEmitter<File | null> = new EventEmitter();
	@Output() getDownloadUrl: EventEmitter<object> = new EventEmitter();
	@ViewChild('fileInput') fileInput!: ElementRef<HTMLInputElement>;
	constructor(private readonly ls: LocalStorageService) {
		this.isAdmin = this.ls.isAdmin;
	}

	fileName: string = '';
	fileId: string = '';
	fileType: string = '';
	baseUrl: string = `${environment.baseUrl}/app`;
	fileUrlFirebase: string = '';
	enablePreview: boolean = false;
	errorSize: boolean = false;
	errorFormat: boolean = false;
	maxSize = maxFileSize;
	allowedExtensions = /(\.jpeg|\.jpg|\.png|\.docx|\.xlsx|\.pdf|\.zip)$/i;
	isAdmin: boolean = false;

	async onFileSelected(event: Event) {
		this.fileUrl = null;
		this.errorSize = false;

		const inputFile = event.target as HTMLInputElement;
		if (inputFile) {
			const file: File | null | undefined = inputFile.files?.item(0);
			
			if (file) {
				if ((file.size / 1000) > this.maxSize) {
					this.errorSize = true;
					alert('Tamaño de archivo muy alto');
					event.preventDefault();
					return;
				}

				if (!this.allowedExtensions.exec(file.name)) {
					this.errorFormat = true;
					alert('Formato de archivo inválido');
					event.preventDefault();
					return;
				}
				this.fileName = file.name;
				this.uploadedFile.emit(file);
			}
		}
	}

	removeFile() {
		const sendMessage = '¿Estas seguro de borrar el documento?';

		showConfirmAlert({
			message: sendMessage,
			type: 'info',
			msgConfirm: 'Confirmar',
			callBack: () => {				
				this.fileInput.nativeElement.value = "";
				this.fileName = '';
				this.uploadedFile.emit(null);
				showAlert('Documento Eliminado');
			}
		});
	}

	ngOnChanges(changes: SimpleChanges): void {
		if (changes['defaultFilename'] && this.defaultFilename && this.fileUrl) {
			this.fileName = this.defaultFilename;
		}
		if (changes['fileUrl']) {
			if (this.fileUrl) {
				const [type, id] = this.fileUrl.split('/');
				this.fileId = id;
				this.fileType = type;

				const extension = this.fileName.split('.').pop();
				if (extension && ['jpg','png','jpeg','gif'].includes(extension.toLowerCase())) {
					this.enablePreview = true;
				}
			}
		}
	}

	/* Funcion deprecated, se deja por si se requiere en un futuro
	getDownloadURI(){
		if(this.fileName === 'kstest.docx' || this.fileName === '2023 PILEOZ. Mag. Andrea Mayorga R..pdf'){
			return null;
		}
		return `${this.baseUrl}/${this.fileId}?type=${this.fileType}&download=${encodeURIComponent(this.fileName)}`;
	} */

	/* 
		Se envian establecen los metadatos del archivo para la descarga del archivo 
		desde el componente padre, llamando al endpoint de conexion con google cloud storage 
	*/
	downloadFile() {
		const features = {
			filePath: this.fileUrl,
			fileName: this.fileName,
		}
		this.getDownloadUrl.emit(features);
	}

}